import { SwitchProductModule } from '@wix/package-picker-sdk';
import { PackagePickerSteps, UrlUtils, wixServerData } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../components';
import { useViewChange } from './useViewChange';
export const useSelectButton = _ref => {
  let {
    productId,
    source
  } = _ref;
  const module = useCurrentModule();
  const {
    locale,
    userId
  } = wixServerData.get();
  const {
    data: product
  } = module.SDK.studioOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    t
  } = module.internals.useTranslations();
  const {
    bi
  } = module.internals;
  const handleViewChange = useViewChange();
  const {
    isEnterprise
  } = product ?? {};
  const productAvailability = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId
  });
  const isDisabled = productAvailability.isLoading || !productAvailability.isProductAvailable;
  const text = isEnterprise ? t('premium-purchase-plan.cards.enterprise.cta') : t('productEntry.select');
  const disabledTooltipContent = t('Advanced.Plans_second.upgrade_plan.disabled.tooltip');
  const handleSelectEnterprise = React.useCallback(() => {
    const ENTERPRISE_FORM_URL = 'https://www.wix.com/enterprise/form';
    const url = UrlUtils.buildUrl({
      url: ENTERPRISE_FORM_URL,
      params: {
        productId,
        localeUrl: ENTERPRISE_FORM_URL,
        referrer: 'studio-pp',
        // TODO: Add actual referrer
        locale,
        userGuid: userId ?? ''
      }
    });
    window.open(url, '_blank');
  }, [productId, locale, userId]);
  const handleContinueToSelectCyclePage = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    module.internals.bi.onContinueToSelectCyclePage == null || module.internals.bi.onContinueToSelectCyclePage({
      productId,
      clickType: source
    });
    handleViewChange(PackagePickerSteps.SELECT_CYCLE, {
      productId: productId || null
    });
  }, [productId, source, module.internals.bi, handleViewChange]);
  const showDowngradeModal = React.useCallback(() => {
    SwitchProductModule.SDK.modalsController.DowngradeModal.show({
      productId,
      callbacks: {
        onShow: props => {
          bi.onDowngradeModalLoad == null || bi.onDowngradeModalLoad(props);
        },
        onClose: props => {
          bi.onDowngradeModalClose == null || bi.onDowngradeModalClose(props);
        },
        onPrimaryButtonClick: props => {
          bi.onDowngradeModalCtaClick == null || bi.onDowngradeModalCtaClick(props);
        },
        onLinkClick: props => {
          bi.onDowngradeModalLinkClick == null || bi.onDowngradeModalLinkClick(props);
        },
        errorCallbacks: {
          onShow: _ref2 => {
            let {
              errorType,
              error
            } = _ref2;
            bi.onDowngradeErrorModalLoad == null || bi.onDowngradeErrorModalLoad({
              errorType,
              errorMessage: error instanceof Error ? `${error.message} ${error.stack}` : 'Unknown error'
            });
          },
          onClose: props => {
            bi.onDowngradeErrorModalClose == null || bi.onDowngradeErrorModalClose(props);
          },
          onClick: _ref3 => {
            let {
              action
            } = _ref3;
            bi.onDowngradeErrorModalClick == null || bi.onDowngradeErrorModalClick({
              action
            });
          }
        },
        successCallbacks: {
          onShow: () => {
            bi.onDowngradeSuccessModalLoad == null || bi.onDowngradeSuccessModalLoad({});
          },
          onClick: _ref4 => {
            let {
              action,
              data
            } = _ref4;
            bi.onDowngradeSuccessModalClick == null || bi.onDowngradeSuccessModalClick({
              action,
              url: (data == null ? void 0 : data.url) ?? ''
            });
          }
        }
      }
    });
  }, [bi, productId]);
  const onClick = React.useCallback(function (_temp) {
    let {
      goToSelectCyclePage = true
    } = _temp === void 0 ? {} : _temp;
    bi.onSelectPlan == null || bi.onSelectPlan({
      productId,
      clickType: source
      // TODO: Add something to indicate enterprise / open modal?
    });
    if (isEnterprise) {
      handleSelectEnterprise();
      return;
    }
    if (productAvailability.isProductAvailable && productAvailability.canDowngrade) {
      showDowngradeModal();
      return;
    }
    if (goToSelectCyclePage) {
      handleContinueToSelectCyclePage();
    }
  }, [bi, productId, source, isEnterprise, productAvailability.isProductAvailable, productAvailability.canDowngrade, handleContinueToSelectCyclePage, handleSelectEnterprise, showDowngradeModal]);
  return {
    text,
    onClick,
    isDisabled,
    disabledTooltipContent
  };
};
//# sourceMappingURL=useSelectButton.js.map